import PropTypes from 'prop-types';
import { Icon } from '@evertrue/et-components';
import { createCadenceShellsColumns } from './cadence-shells-columns';
import CadenceFlexTable from './cadence-flex-table';

const TOGGLEABLE = [
  'type',
  'status',
  'totalCadences',
  'createdBy',
  'typicalPerformance',
  'automation',
  'createdDate',
  'avgDeliveryRate',
  'avgBounceRate',
  'avgUnsubscribeRate',
  'avgOpenRate',
  'avgClickRate',
  'avgReplyRate',
  'lastUpdated',
  'tags',
];

const HIDDEN_COLUMNS = {
  automation: false,
  createdDate: false,
  avgDeliveryRate: false,
  avgBounceRate: false,
  avgUnsubscribeRate: false,
  avgOpenRate: false,
  avgClickRate: false,
  avgReplyRate: false,
  lastUpdated: false,
};

const CadenceShellsTable = ({ data, loading, currentUserId, actions, renamingState, onSelectionChange }) => (
  <CadenceFlexTable
    tableKey="cadences-v2-cadence-shells"
    columns={createCadenceShellsColumns({ currentUserId, actions, renamingState })}
    data={data}
    loading={loading}
    onSelectionChange={onSelectionChange}
    toggleableColumns={TOGGLEABLE}
    columnVisibilityModel={HIDDEN_COLUMNS}
    showQuickFilter={false}
    emptyStateMessage="No Cadence Blueprints found"
    emptyStateIcon={<Icon icon="cadences" iconKit="gt2" size={5} />}
  />
);

CadenceShellsTable.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  currentUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  actions: PropTypes.object,
  renamingState: PropTypes.object,
  onSelectionChange: PropTypes.func,
};

export default CadenceShellsTable;
